import React, { useState } from 'react'
import AttendanceTodayList from './AttendanceTodayList'
import AttendanceActions from './AttendanceActions'
import AttendanceLeaveTodayList from './AttendanceLeaveTodayList'

export default function AttendanceManager() {
    const [activeTab, setActiveTab] = useState('attendance') // 'attendance' or 'leave'

    return (
        <div className="min-h-screen flex flex-col lg:flex-row">
            {/* Left Container with Tab Header */}
            <div className="lg:w-1/2 w-full bg-gray-100 p-4">
                {/* Tabs */}
                <div className="flex space-x-4 mb-4">
                    <button
                        onClick={() => setActiveTab('attendance')}
                        className={`px-4 py-2 rounded font-semibold transition-colors duration-200 ${
                            activeTab === 'attendance'
                                ? 'bg-red-600 text-white'
                                : 'bg-gray-200 text-gray-800 hover:bg-red-100'
                        }`}
                    >
                        Attendance Today
                    </button>
                    <button
                        onClick={() => setActiveTab('leave')}
                        className={`px-4 py-2 rounded font-semibold transition-colors duration-200 ${
                            activeTab === 'leave'
                                ? 'bg-red-600 text-white'
                                : 'bg-gray-200 text-gray-800 hover:bg-red-100'
                        }`}
                    >
                        Leave Today
                    </button>
                </div>

                {/* Conditional Content */}
                {activeTab === 'attendance' && <AttendanceTodayList />}
                {activeTab === 'leave' && <AttendanceLeaveTodayList />}
            </div>

            {/* Right Container */}
            <div className="lg:w-1/2 w-full bg-white p-4">
                <AttendanceActions />
            </div>
        </div>
    )
}
